import { API_BASE_URL, StatusCode } from 'constants/index'
import fetchHelper from 'helpers/FetchHelper'
import useSWR from 'swr'
import SWR_KEY from './constant'

export const useSetting = (options = {}) => {
  const getData = async () =>
    await fetchHelper
      .fetch(`${API_BASE_URL}${SWR_KEY.SETTINGS}`, {
        method: 'GET',
      })
      .then(([res, status]: any) => {
        if (status === StatusCode.OK) return res?.data
        return undefined
      })

  return useSWR(SWR_KEY.SETTINGS, getData, {
    revalidateOnFocus: false,
    ...options,
  })
}

export const useConfig = (options = {}) => {
  const getData = async () =>
    await fetchHelper
      .fetch(`${API_BASE_URL}${SWR_KEY.CONFIG}`, {
        method: 'GET',
      })
      .then(([res, status]: any) => {
        if (status === StatusCode.OK) return res?.data
        return undefined
      })

  return useSWR(SWR_KEY.CONFIG, getData, {
    revalidateOnFocus: false,
    ...options,
  })
}
